// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1E0_O","content":"styles_content__LpDhL","tableWrap":"styles_tableWrap___Nfu5"};